import React from "react";
import { Typography } from "@mui/material";
import { WITHDRAW_DEPOSIT_HISTORY_TABS } from "../../constants";

function Side({ data }) {
  return (
    <Typography
      variant="h6"
      fontWeight={400}
      color={
        data?.sideId === WITHDRAW_DEPOSIT_HISTORY_TABS.deposit.id
          ? "success.main"
          : "error.main"
      }
    >
      {data?.side}
    </Typography>
  );
}

export default Side;
